<script setup>
  const props = defineProps({
    visible: {
      type: Boolean,
      required: true,
      default: false,
    },
    showCancelButton: {
      type: Boolean,
      default: true,
    },
    cancelButtonText: {
      type: String,
      default: 'キャンセル',
    },
    showComfirmButton: {
      type: Boolean,
      default: true,
    },
    confirmButtonText: {
      type: String,
      default: 'OK',
    },
    alert: {
      type: Boolean,
      default: false,
    },
    small: {
      type: Boolean,
      default: false,
    },
    dark: {
      type: Boolean,
      default: true,
    },
  })

  const emit = defineEmits(['update:visible', 'confirm'])

  const onClose = () => {
    emit('update:visible', false)
    if (props.showCancelButton) {
      emit('confirm', false)
    }
  }

  const onConfirm = () => {
    emit('update:visible', false)
    emit('confirm', true)
  }
</script>

<template>
  <div class="popup-text fadein" :class="{ small: small, dark: dark }" v-if="visible">
    <div class="popup-content">
      <button class="close" type="button"><span class="material-symbols-outlined" @click="onClose">close</span></button>
      <slot name="top"></slot>
      <div class="popup-title">
        <span class="material-symbols-outlined" v-if="alert">warning</span>
        <slot name="title"></slot>
      </div>
      <div class="popup-body scroller">
        <slot name="content"></slot>
      </div>
      <div class="popup-action">
        <button type="button" @click="onClose" class="input-cancel" v-if="showCancelButton">{{ cancelButtonText }}</button>
        <button type="button" @click="onConfirm" class="input-submit" :style="{ backgroundColor: !alert ? 'var(--active-color)' : 'var(--alert-color)' }" v-if="showComfirmButton">{{ confirmButtonText }}</button>
      </div>
    </div>
  </div>
</template>

<style lang="less" scoped></style>
